import { createContext, useContext } from 'react';

export const HoverActionsFieldContext = createContext({
  onInteractionActiveChange: () => {},
  registerOverlayAnchor: () => {},
  isOverlayVisible: false,
});

export const useHoverActionsField = () => useContext(HoverActionsFieldContext);
